import { FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { MultiSelect } from "../ui/multi-select";

type FormMultiSelectProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	label?: string;
	placeholder: string;
	options: {
		value: string;
		label: string;
		icon?: string;
	}[];

};

export const FormMultiSelect = <T extends FieldValues>({
	form,
	name,
	label,
	placeholder,
	options,
}: FormMultiSelectProps<T>) => {
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<FormLabel className="flex items-center gap-1 font-semibold">
						{label}
					</FormLabel>
					<FormControl>
						<MultiSelect
							className="py-6 pl-4 border border-border rounded-xl h-16 font-semibold placeholder:text-tertiary resize-none"
							placeholder={placeholder}
							defaultValue={field.value ? field.value : []}
							{...field}
							options={[
								...options.map((option) => ({
									value: option.value,
									label: option.label,
									icon: option.icon,
								})),
							]}
							onValueChange={(e) => {
								field.onChange(e);
							}}
						/>
					</FormControl>
				</FormItem>
			)}
		/>
	);
};
